import ReviewsContainer from './reviews-container';

export default ReviewsContainer;
